import React from 'react';
import { Box } from '@mui/material';
import TimeOffRequestsPanel from '../components/hr/TimeOffRequestsPanel';

const TimeOffRequests = () => (
  <Box>
    <TimeOffRequestsPanel />
  </Box>
);

export default TimeOffRequests;
